import anime from "animejs";
import ScrollMagic from "scrollmagic";

const entryTitleAnimation = () => {
  const allTextToAnimate = document.querySelectorAll(".entry-text-animation");
  if (!allTextToAnimate) return;

  allTextToAnimate.forEach((element) => {
    const animation = () => {
      element.innerHTML = element.textContent.replace(
        /\S/g,
        "<span class='letter'>$&</span>"
      );
      let letters = element.querySelectorAll(".letter");

      anime.timeline({ loop: false }).add({
        targets: letters,
        opacity: [0, 1],
        easing: "easeInOutQuad",
        duration: 500,
        delay: (el, i) => 10 * (i + 1),
      });
    };
    const controller = new ScrollMagic.Controller();
    const scene = new ScrollMagic.Scene({
      triggerHook: "onEnter",
      triggerElement: element,
      reverse: false,
    })
      .on("start", () => {
        animation();
      })
      .addTo(controller);
  });
};

export { entryTitleAnimation };
